import template from './sw-cms-el-preview-acris-blog-group.html.twig';
import './sw-cms-el-preview-acris-blog-group.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-group', {
    template
});
